(function ($) {
    $(document).ready(function() {

        //Cojo los group leaders del research group actual de la cabecera
        var mainResearchers=document.querySelectorAll('.research-group__field-resgr-main-researchers > .field__item');
        //Si hay más de uno...
        if(mainResearchers.length > 1){
          //... Añado el nombre del investigador al grupo
          var groupMembersSection = document.querySelector(".group-members");
          var group1group2 = groupMembersSection.querySelectorAll(".container>.layout>.col-12>.block");
          Array.prototype.forEach.call(group1group2, function(value, i) {
            var groupMembers = group1group2[i].querySelectorAll(".group-members .views-element-container .views-row");
            var groupTitle = group1group2[i].querySelectorAll(".block h2");
            var firstMember = groupMembers[0].querySelectorAll(".views-field-title span a")[0].innerHTML;
            groupTitle[0].innerHTML = ' Group ' + firstMember ;
          });
          //... itero en cada uno, formateando nombre y apellido...
          Array.prototype.forEach.call(mainResearchers, function(element, index) {
            var mainResearcher = element.querySelectorAll(".researcher .layout .block span a")[0].innerHTML;
            mainResearcher = nameSur(mainResearcher);
            //... y si no es el del hash...
            if (window.location.hash != ""){
              if(mainResearcher != window.location.hash.replace("#","")){
                //... lo borro de la cabecera
                mainResearchers[index].style.display="none";
                //... Pongo el grupo del indicado primero
                var groupMembersSection = document.querySelector(".group-members");
                var group1group2 = groupMembersSection.querySelectorAll(".container>.layout>.col-12>.block");
                Array.prototype.forEach.call(group1group2, function(value, i) {
                  var groupMembers = group1group2[i].querySelectorAll(".group-members .views-element-container .views-row");
                  Array.prototype.forEach.call(groupMembers, function(side, j) {
                    var member = side.querySelectorAll(".views-field-title span a")[0].innerHTML;
                    member = nameSur(member);
                    if(window.location.hash.replace("#","") == member){
                      group1group2[i].parentNode.insertBefore(group1group2[i], group1group2[0]);
                    };
                  });
                });
                //... para borrar al líder no presente de de los group members
                /*
                var groupMembers = document.querySelectorAll("#research_group_members_block .views-row");
                Array.prototype.forEach.call(groupMembers, function(side, i) {
                  var member = side.querySelectorAll(".views-field-title span a")[0].innerHTML;
                  member = nameSur(member);
                  if(mainResearcher == member){
                    groupMembers[i].style.display="none";
                  };
                });
                */

              };
            };
          });
        };
        removeHash();
    });

    //Función para formatear pasar un nombre completo a sus dos primeras palabras, con guiones por espacios, sin mayúsculas ni caracteres raros
    //Actualizado a tomar las palabras segunda y tercera (por la inclusión de Dr/Dra) y limpiar espacios extraños (trim())
    function nameSur(nameSurname){
        var noDots = nameSurname.split('.').join("").trim();
        var twoFirstWords = noDots.split(' ').slice(1,3).join(' ');
        var noSpacesNoUppercase = twoFirstWords.replace(/\s+/g, '-').toLowerCase();
        var noWeirdCharacters = noSpacesNoUppercase.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return noWeirdCharacters;
    }
    /*
    function nameSur(nameSurname){
        var noDots = nameSurname.split('.').join("");
        var twoFirstWords = noDots.split(' ').slice(0,2).join(' ');
        var noSpacesNoUppercase = twoFirstWords.replace(/\s+/g, '-').toLowerCase();
        var noWeirdCharacters = noSpacesNoUppercase.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return noWeirdCharacters;
    }
    */

    //Eliminar el hash
    function removeHash () {
     history.pushState("", document.title, window.location.pathname + window.location.search);
    }
})(jQuery, Drupal);